import { useCallback } from 'react';

import useDefaultErrorSnackbar from '@/hooks/useDefaultErrorSnackbar';
import { UpdateSurveyInput } from '@/types/schema';

import { useUpdateSurveyMutation } from '../../graphql/mutations/generated/updateSurvey';

const useSurveyEditorMutations = () => {
  const { showDefaultErrorSnackbar } = useDefaultErrorSnackbar();
  const [updateSurveyResponse, executeUpdateSurvey] = useUpdateSurveyMutation();

  const onUpdateSurvey = useCallback(
    async (data: UpdateSurveyInput) => {
      const response = await executeUpdateSurvey({
        data: { ...data, maintainDraftState: true },
      });
      if (response.error) {
        showDefaultErrorSnackbar();
      }
      return { response };
    },
    [executeUpdateSurvey, showDefaultErrorSnackbar],
  );

  return {
    isSaving: updateSurveyResponse.fetching,
    onUpdateSurvey,
  };
};

export default useSurveyEditorMutations;
